import React from 'react'

export default function Header() {
  return (
    <header className='mb-4'>
      <h3 className='heading1 fw-bold'>Expense Tracker</h3>
    </header>
  )
}
